import { useState, useEffect } from "react";
import Paginate from "../Components/Paginate";
import axios from "../shared";
import useAuth from "../Hooks/useAuth";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const Doctors = () => {
  const { auth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const [users, setUsers] = useState();
  const [specializationList, setSpecializationList] = useState([]);
  const [limit] = useState("9");
  const [pageCount, setpageCount] = useState(0);
  const [count, setCount] = useState(0);
  const [endValue, setEndValue] = useState(0);
  const [startValue, setStartValue] = useState(1);
  const [searchName, setSearchName] = useState("");
  const [searchSpecialization, setSearchSpecialization] = useState("");
  const [cancelActive, setCancelActive] = useState(false);

  // css style for description of doctor to show only fixed lines followed by ellipsis
  const contentStyles = {
    maxHeight: "4em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    WebkitBoxOrient: "vertical",
  };

  useEffect(() => {
    const url = `user/doctor?limit=${limit}&active`;
    getInitialUsers(url);

    //gets the list of category
    const getSpecialization = async () => {
      const response = await axios.get("user/doctor/specialization");
      setSpecializationList(response.data);
    };

    getSpecialization();
  }, []);

  const getInitialUsers = async (url) => {
    var response;
    if (auth.length > 0) {
      response = await axiosPrivate.get(url);
    } else {
      response = await axios.get(url);
    }
    //sets the list of data got from api
    setUsers(response?.data.results);
    //gets the total record and divides by 9 to set pagination number
    setpageCount(Math.ceil(response.data.count / 9));
    //sets the total number of record to display in bottom message
    setCount(response?.data.count);
    //sets the start and end value as length of records got
    setStartValue(1);
    setEndValue(response?.data.results.length);
  };

  const getUsers = async (url) => {
    var response;
    if (auth.length > 0) {
      response = await axiosPrivate.get(url);
    } else {
      response = await axios.get(url);
    }
    return response;
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected * limit;

    //replaces whitespace with %20
    const doctor_name = searchName.replace(/\s/g, "%20");
    const specialization = searchSpecialization.replace(/\s/g, "%20");

    const url = `user/doctor/?limit=${limit}&offset=${currentPage}&name=${doctor_name}&specialization=${specialization}`;

    //calls the api with limit and currentpage as offset and get response data
    const response = await getUsers(url);

    //sets response into list
    setUsers(response?.data.results);
    //sets start and end value
    setStartValue(data.selected * limit + 1);
    setEndValue(data.selected * limit + response?.data.results.length);
    if (response?.data.results.length === 0) {
      setStartValue(0);
      setEndValue(0);
    }
  };

  const onChange = (e) => {
    setSearchName(e.target.value);
  };

  const search = async (e) => {
    if (e.key === "Enter") {
      //replaces white space with %20
      const doctor_name = searchName.replace(/\s/g, "%20");
      const specialization = searchSpecialization.replace(/\s/g, "%20");

      const url = `user/doctor/?limit=${limit}&name=${doctor_name}&specialization=${specialization}`;
      await getInitialUsers(url);

      //activates the reset filter button
      setCancelActive(true);
    }
  };

  const onSearch = async (e) => {
    if (e.target.value !== "Specialization") {
      setSearchSpecialization(e.target.value);

      //replaces white space with %20
      const doctor_name = searchName.replace(/\s/g, "%20");
      const specialization = e.target.value.replace(/\s/g, "%20");

      const url = `user/doctor/?limit=${limit}&name=${doctor_name}&specialization=${specialization}`;
      await getInitialUsers(url);

      //activates the reset filter button
      setCancelActive(true);
    }
  };

  const onCancel = async (e) => {
    //deactivates the reset filter button
    setCancelActive(false);
    //clears the name and specialization
    setSearchName("");
    setSearchSpecialization("");

    //sets the value of selected to Specialization
    const inputState = document.getElementById("inputState");
    inputState.value = "Specialization";

    const url = `user/doctor?limit=${limit}`;
    await getInitialUsers(url);
  };

  return (
    <div className="m-2">
      <h2 className="mt-3 text-center">Available Doctors</h2>
      <hr />
      <div className="d-flex justify-content-end flex-column flex-md-row">
        <input
          type="text"
          className="form-label me-4 mt-1"
          placeholder="Name and Press Enter"
          value={searchName}
          onChange={onChange}
          onKeyUp={search}
          style={{ width: 12 + "rem" }}
        />
        <div className="d-flex">
          <select
            id="inputState"
            className="form-select me-2"
            style={{ width: 15 + "rem" }}
            onClick={onSearch}
          >
            <option value="Specialization">Specialization</option>
            {specializationList.length > 0 &&
              specializationList.map((specialization, i) => (
                <option key={i} value={specialization}>
                  {specialization}
                </option>
              ))}
          </select>
          {cancelActive && (
            <button className="ms-4 btn btn-primary" onClick={onCancel}>
              <i className="fas fa-xmark p-1"></i>
            </button>
          )}
        </div>
      </div>
      <hr />
      {users?.length ? (
        <div className="mx-2 mx-md-4 mt-1 row row-cols-1 row-cols-md-3 g-5">
          {users.map(
            (user, i) =>
              user.user_detail.is_active && (
                <div className="col mt-3" key={i}>
                  <div className="card mb-3 text-bg-light">
                    <div className="row g-0 mt-1">
                      <div className="col-md-4 my-auto text-center">
                        <img
                          src={user?.user_detail["user_image"]}
                          className="rounded border"
                          width={110}
                          height={130}
                          alt="doctor"
                        />
                      </div>
                      <div className="col-md-8">
                        <div className="card-body">
                          <h4 className="card-title text-center text-truncate">
                            Dr. {user?.user_detail["name"]}
                          </h4>
                          <p className="card-text mb-1 text-truncate">
                            <strong>Specialization:</strong>{" "}
                            {user?.specialization}
                          </p>
                          <div className=" text-truncate">
                            <p className="card-text mb-1 d-inline">
                              <strong>Degree: </strong>
                            </p>
                            {user?.education.length ? (
                              user?.education.map((education, j) => (
                                <p
                                  className="mx-1 badge bg-secondary mb-1"
                                  key={j}
                                >
                                  {education.degree}
                                </p>
                              ))
                            ) : (
                              <label className="m-0 mb-1">N/A</label>
                            )}
                          </div>
                          <p className="card-text mb-1" style={contentStyles}>
                            {user?.description}
                          </p>
                          <div className="text-end">
                            <a
                              href={`doctor/${user?.user}`}
                              className="btn btn-primary p-1"
                            >
                              See More
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
          )}
        </div>
      ) : (
        <p className="text-center fs-4">No doctors to display</p>
      )}
      <div className="mx-4 px-4">
        <Paginate
          startValue={startValue}
          endValue={endValue}
          count={count}
          pageCount={pageCount}
          handlePageClick={handlePageClick}
        />
      </div>
    </div>
  );
};

export default Doctors;
